import { ElasticModalForm } from "../modals/ElasticModal";
import { SplunkModalForm } from "../modals/SplunkModal";
import { CoralogixModalForm } from "../modals/CoralogixModal";
import { GlobalRelayModalForm } from "../modals/GlobalRelayModal";
import { CustomS3ModalForm } from "../modals/CustomS3Modal";
import { R2ModalForm } from "../modals/R2Modal";
import { AzureBlobModalForm } from "../modals/AzureBlobModal";
import { SalesforceModalForm } from "../modals/SalesforceModal";
import { InternalS3ModalForm } from "../modals/InternalS3Modal";
import { VerintModalForm } from "../modals/VerintModal";
import { GoogleCloudStorageModalForm } from "../modals/GoogleCloudStorageModal";
import { QradarModalForm } from "../modals/QradarModal";
import { DynamicsModalForm } from "../modals/DynamicsModal";
import { DESTINATION_INTEGRATION_TYPES } from "@whatslly/types/messages-server/destinations";
import { DESTINATION_NAMES } from "@whatslly/commons/destinationNames";
import { AmazonTranscribeModalForm } from "../modals/AmazonTranscribeModal";
import { AzureSpeechTranscribeModalForm } from "../modals/AzureSpeechTranscribeModal";
import { SFTPModalForm } from "../modals/SFTPModal";
import { ProofPointModalForm } from "../modals/ProofPointModal";
import { CrowdstrikeModalForm } from "../modals/CrowdstrikeModal";
import { SalesforceDataCloudModalForm } from "../modals/SalesforceDataCloudModal";
import { HubspotModalForm } from "../modals/HubspotModal";
import { PipedriveModalForm } from "../modals/PipedriveModal";
import { ForcepointDlpDetectorModalForm } from "../modals/ForcepointDlpDetectorModal";
import type { UserType } from "@whatslly/types/User";
import keyBy from "lodash/keyBy";
import { MicrosoftPurviewModalForm } from "../modals/MicrosoftPurviewModal";
import { SentinelModalForm } from "../modals/SentinelModal";
import { OpenAiModalForm, AnthropicModalForm, GoogleAiModalForm } from "../modals/ApiKeyProviderModal";
import { AzureOpenAiModalForm } from "../modals/AzureOpenAiModal";
import { BedrockModalForm } from "../modals/BedrockModal";
import { InternalAzureOpenAiModalForm } from "../modals/InternalAzureOpenAiModal";
import type { DestinationListEntry } from "./DestinationsListTypes";
import { GoogleSecOpsModalForm } from "../modals/GoogleSecOpsForm";

const SecurityPlaceholderForm = () => null;

export const DestinationList: DestinationListEntry[] = [
  {
    id: "pipedrive",
    name: DESTINATION_NAMES["pipedrive"],
    category: "CRM",
    form: PipedriveModalForm,
    type: "pipedrive",
    img: "https://assets.whatslly.com/product/img/logos/destination-pipedrive.png",
    className: "pipedrive",
    wrapperClassName: "centerContent",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "hubspot",
    name: DESTINATION_NAMES["hubspot"],
    category: "CRM",
    form: HubspotModalForm,
    type: "hubspot",
    img: "https://assets.whatslly.com/product/img/logos/destination-hubspot.png",
    className: "hubspot",
    wrapperClassName: "centerContent",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "openai",
    name: DESTINATION_NAMES["openai"],
    category: "LLM Provider",
    form: OpenAiModalForm,
    type: "openai",
    img: "https://assets.whatslly.com/product/img/logos/destination-openai.svg",
    className: "llm-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "anthropic",
    name: DESTINATION_NAMES["anthropic"],
    category: "LLM Provider",
    form: AnthropicModalForm,
    type: "anthropic",
    img: "https://assets.whatslly.com/product/img/logos/destination-anthropic.svg",
    className: "anthropic-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "google-ai",
    name: DESTINATION_NAMES["google"],
    category: "LLM Provider",
    form: GoogleAiModalForm,
    type: "google",
    img: "https://assets.whatslly.com/product/img/logos/destination-google-ai.svg",
    className: "llm-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "azure-openai",
    name: DESTINATION_NAMES["azure_openai"],
    category: "LLM Provider",
    form: AzureOpenAiModalForm,
    type: "azure_openai",
    img: "https://assets.whatslly.com/product/img/logos/destination-azure-openai.svg",
    className: "llm-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "bedrock",
    name: DESTINATION_NAMES["bedrock"],
    category: "LLM Provider",
    form: BedrockModalForm,
    type: "bedrock",
    img: "https://assets.whatslly.com/product/img/logos/destination-aws-2.svg",
    className: "llm-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "internal-azure-openai",
    name: DESTINATION_NAMES["internalAzureOpenAi"],
    category: "LLM Provider",
    form: InternalAzureOpenAiModalForm,
    type: "internalAzureOpenAi",
    img: "https://assets.whatslly.com/product/img/logos/destination-azure-openai.svg",
    className: "llm-img",
    wrapperClassName: "centerContent",
    isActive: (user: UserType | undefined) => user?.isSuperAdmin || user?.isAdmin || import.meta.env.MODE === "test",
    integrationType: DESTINATION_INTEGRATION_TYPES.LLM_PROVIDER,
  },
  {
    id: "azure-ai-speech",
    name: DESTINATION_NAMES["azureSpeechTranscribe"],
    category: "",
    form: AzureSpeechTranscribeModalForm,
    type: "azureSpeechTranscribe",
    img: "https://assets.whatslly.com/product/img/logos/destination-azspeech.png",
    className: "amazon-trascribe-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIO_TRANSCRIBES,
  },
  {
    id: "amazon-transcribe",
    name: DESTINATION_NAMES["amazonTranscribe"],
    category: "",
    form: AmazonTranscribeModalForm,
    type: "amazonTranscribe",
    img: "https://assets.whatslly.com/product/img/logos/destination-amazon-transcribe.png",
    className: "amazon-trascribe-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIO_TRANSCRIBES,
  },
  {
    id: "google-sec-ops-audit-log",
    name: DESTINATION_NAMES["googleSecOpsAuditLog"],
    category: "destinations_page.compliance",
    form: GoogleSecOpsModalForm,
    type: "googleSecOpsAuditLog",
    img: `https://assets.whatslly.com/product/img/logos/destination-google-sec-ops.png`,
    className: "google-sec-ops-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIT_LOGS,
  },
  {
    id: "google-sec-ops-dlp-incident",
    name: DESTINATION_NAMES["googleSecOpsDlpIncident"],
    category: "destinations_page.compliance",
    form: GoogleSecOpsModalForm,
    type: "googleSecOpsDlpIncident",
    img: "https://assets.whatslly.com/product/img/logos/destination-google-sec-ops.png",
    className: "google-sec-ops-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_INCIDENTS,
  },
  {
    id: "splunk-audit-log",
    name: DESTINATION_NAMES["splunkAuditLog"],
    category: "destinations_page.compliance",
    form: SplunkModalForm,
    type: "splunkAuditLog",
    img: "https://assets.whatslly.com/product/img/logos/destination-splunk.svg",
    className: "splunk-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIT_LOGS,
  },
  {
    id: "splunk-dlp-incident",
    name: DESTINATION_NAMES["splunkDlpIncident"],
    category: "destinations_page.compliance",
    form: SplunkModalForm,
    type: "splunkDlpIncident",
    img: "https://assets.whatslly.com/product/img/logos/destination-splunk.svg",
    className: "splunk-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_INCIDENTS,
  },
  {
    id: "elastic-audit-log",
    name: DESTINATION_NAMES["elasticAuditLog"],
    category: "destinations_page.compliance",
    form: ElasticModalForm,
    type: "elasticAuditLog",
    img: "https://assets.whatslly.com/product/img/logos/destionation-elasticsearch.svg",
    className: "elasticsearch-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIT_LOGS,
  },
  {
    id: "elastic-dlp-incident",
    name: DESTINATION_NAMES["elasticDlpIncident"],
    category: "destinations_page.compliance",
    form: ElasticModalForm,
    type: "elasticDlpIncident",
    img: "https://assets.whatslly.com/product/img/logos/destionation-elasticsearch.svg",
    className: "elasticsearch-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_INCIDENTS,
  },
  {
    id: "salesforce",
    name: DESTINATION_NAMES["salesforce"],
    category: "CRM",
    form: SalesforceModalForm,
    type: "salesforce",
    img: "https://assets.whatslly.com/product/img/salesforce-icon.png",
    className: "salesforce-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "salesforce-data-cloud",
    name: DESTINATION_NAMES["salesforceDataCloud"],
    category: "Warehouse",
    form: SalesforceDataCloudModalForm,
    type: "salesforceDataCloud",
    img: "https://assets.whatslly.com/product/img/salesforce-icon.png",
    className: "salesforce-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "microsoft-dynamics",
    name: DESTINATION_NAMES["dynamics"],
    category: "CRM",
    form: DynamicsModalForm,
    type: "dynamics",
    img: "https://assets.whatslly.com/product/img/dynamics_logo.svg",
    className: "dynamics-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "crowdstrike-siem",
    name: DESTINATION_NAMES["crowdstrike"],
    category: "destinations_page.compliance",
    form: CrowdstrikeModalForm,
    type: "crowdstrike",
    img: "https://assets.whatslly.com/product/img/logos/destination-crowdstrike.png",
    className: "crowdstrike-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "splunk",
    name: DESTINATION_NAMES["splunk"],
    category: "destinations_page.compliance",
    form: SplunkModalForm,
    type: "splunk",
    img: "https://assets.whatslly.com/product/img/logos/destination-splunk.svg",
    className: "splunk-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "coralogix",
    name: DESTINATION_NAMES["coralogix"],
    category: "destinations_page.compliance",
    form: CoralogixModalForm,
    type: "coralogix",
    img: "https://assets.whatslly.com/product/img/logos/destination-coralogix-2.png",
    className: "coralogix-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "global-relay",
    name: DESTINATION_NAMES["smtp"],
    category: "destinations_page.compliance",
    form: GlobalRelayModalForm,
    type: "smtp",
    img: "https://assets.whatslly.com/product/img/logos/destination-globalrelay.png",
    className: "smtp-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "forcepoint",
    name: DESTINATION_NAMES["forcepointDlpDetector"],
    category: "destinations_page.compliance",
    form: ForcepointDlpDetectorModalForm,
    type: "forcepointDlpDetector",
    img: "https://assets.whatslly.com/product/img/logos/destination-forcepoint.svg",
    className: "forcepoint-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_DETECTORS,
  },
  {
    id: "microsoft-purview",
    name: DESTINATION_NAMES["microsoftPurviewDlpDetector"],
    category: "destinations_page.compliance",
    form: MicrosoftPurviewModalForm,
    type: "microsoftPurviewDlpDetector",
    img: "https://assets.whatslly.com/product/img/logos/destination-purview.png",
    className: "purview-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_DETECTORS,
  },
  {
    id: "proofpoint",
    name: DESTINATION_NAMES["proofpoint"],
    category: "destinations_page.compliance",
    form: ProofPointModalForm,
    type: "proofpoint",
    img: "https://assets.whatslly.com/product/img/logos/destionation-proofpoint.png",
    className: "proofpoint-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "amazon-s3",
    name: DESTINATION_NAMES["customS3"],
    category: "destinations_page.blob_storage",
    form: CustomS3ModalForm,
    type: "customS3",
    img: "https://assets.whatslly.com/product/img/logos/destination-aws-2.svg",
    className: "customS3-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "cloudflare-r2",
    name: DESTINATION_NAMES["r2"],
    category: "destinations_page.blob_storage",
    form: R2ModalForm,
    type: "r2",
    img: "https://assets.whatslly.com/product/img/logos/destination-cloudflare-r2.svg",
    className: "r2-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "sftp",
    name: DESTINATION_NAMES["sftp"],
    category: "destinations_page.blob_storage",
    form: SFTPModalForm,
    type: "sftp",
    img: "https://assets.whatslly.com/product/img/logos/destination-sftp.png",
    className: "sftp-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "internal-amazon-s3",
    name: DESTINATION_NAMES["internalS3"],
    category: "destinations_page.blob_storage",
    form: InternalS3ModalForm,
    type: "internalS3",
    img: "https://assets.whatslly.com/product/img/logos/destination-aws-2.svg",
    className: "customS3-img",
    isActive: (user: UserType | undefined) => user?.isSuperAdmin || user?.isAdmin || import.meta.env.MODE === "test",
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "azure-storage",
    name: DESTINATION_NAMES["azureBlob"],
    category: "destinations_page.blob_storage",
    form: AzureBlobModalForm,
    type: "azureBlob",
    img: "https://assets.whatslly.com/product/img/logos/destination-azure.svg",
    className: "azureBlob-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "verint",
    name: DESTINATION_NAMES["verint"],
    category: "destinations_page.compliance",
    form: VerintModalForm,
    type: "verint",
    img: "https://assets.whatslly.com/product/img/logos/destination-verint.svg",
    className: "verint-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "google-cloud-storage",
    name: DESTINATION_NAMES["googleCloudStorage"],
    category: "destinations_page.blob_storage",
    form: GoogleCloudStorageModalForm,
    type: "googleCloudStorage",
    img: "https://assets.whatslly.com/product/img/logos/destination-google-cloud-storage.svg",
    className: "customS3-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "qradar",
    name: DESTINATION_NAMES["qradar"],
    category: "destinations_page.compliance",
    form: QradarModalForm,
    type: "qradar",
    img: "https://assets.whatslly.com/product/img/logos/destination-qradar.png",
    className: "qradar-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.MESSAGES,
  },
  {
    id: "qradar-audit-log",
    name: DESTINATION_NAMES["qradarAuditLog"],
    category: "destinations_page.compliance",
    form: QradarModalForm,
    type: "qradarAuditLog",
    img: "https://assets.whatslly.com/product/img/logos/destination-qradar.png",
    className: "qradar-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.AUDIT_LOGS,
  },
  {
    id: "qradar-dlp-incident",
    name: DESTINATION_NAMES["qradarDlpIncident"],
    category: "destinations_page.compliance",
    form: QradarModalForm,
    type: "qradarDlpIncident",
    img: "https://assets.whatslly.com/product/img/logos/destination-qradar.png",
    className: "qradar-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_INCIDENTS,
  },
  {
    id: "sentinel-dlp-incident",
    name: DESTINATION_NAMES["sentinelDlpIncident"],
    category: "destinations_page.compliance",
    form: SentinelModalForm,
    type: "sentinelDlpIncident",
    img: "https://assets.whatslly.com/product/img/logos/microsoft-sentinel-logo.jpg",
    className: "sentinel-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.DLP_INCIDENTS,
  },
  {
    id: "palo-alto-firewall",
    name: DESTINATION_NAMES["paloAltoFirewall"],
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "paloAltoFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-palo-alto-firewall.png",
    className: "paloAlto-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "checkpoint-firewall",
    name: DESTINATION_NAMES["checkpointFirewall"],
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "checkpointFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-checkpoint.svg",
    className: "checkpoint-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "sentinel-one-firewall",
    name: DESTINATION_NAMES["sentinelOneFirewall"],
    category: "Endpoint protection",
    form: SecurityPlaceholderForm,
    type: "sentinelOneFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-sentinel-one-firewall.png",
    className: "sentinelOne-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "skyhigh-proxy",
    name: DESTINATION_NAMES["skyhighProxy"],
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "skyhighProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-skyhigh.png",
    className: "skyhigh-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "netskope-casb-proxy",
    name: DESTINATION_NAMES["netskopeCasbProxy"],
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "netskopeCasbProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-netskope.webp",
    className: "netskope-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "crowdstrike-endpoint-protection",
    name: DESTINATION_NAMES["crowdStrikeEndpointProtection"],
    category: "Endpoint protection",
    form: SecurityPlaceholderForm,
    type: "crowdStrikeEndpointProtection",
    img: "https://assets.whatslly.com/product/img/logos/destination-crowdstrike.png",
    className: "crowdstrikeSecurity-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "broadcom-proxysg-proxy",
    name: DESTINATION_NAMES["broadcomProxySg"],
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "broadcomProxySg",
    img: "https://assets.whatslly.com/product/img/logos/destination-broadcom.png",
    className: "broadcom-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "forcepoint-proxy-websecurity",
    name: DESTINATION_NAMES["forcepointProxyWebSecurity"],
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "forcepointProxyWebSecurity",
    img: "https://assets.whatslly.com/product/img/logos/destination-forcepoint.png",
    className: "forcepointSecurity-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "fortinet-fortigate-proxy",
    name: DESTINATION_NAMES["fortinetFortigateProxy"],
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "fortinetFortigateProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-fortinet.webp",
    className: "fortinet-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "trellix-proxy",
    name: DESTINATION_NAMES["trellixProxy"],
    category: "Endpoint protection",
    form: SecurityPlaceholderForm,
    type: "trellixProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-trellix.png",
    className: "trellix-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "trend-micro-ee-endpoint-protection",
    name: DESTINATION_NAMES["trendMicroEeEndpointProtection"],
    category: "Endpoint protection",
    form: SecurityPlaceholderForm,
    type: "trendMicroEeEndpointProtection",
    img: "https://assets.whatslly.com/product/img/logos/destination-trend-micro.png",
    className: "trendMicro-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "kaspersky-endpoint",
    name: DESTINATION_NAMES["kasperskyEndpoint"],
    category: "Endpoint",
    form: SecurityPlaceholderForm,
    type: "kasperskyEndpoint",
    img: "https://assets.whatslly.com/product/img/logos/destination-kaspersky.png",
    className: "kaspersky-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "zscaler-proxy",
    name: DESTINATION_NAMES["zscalerProxy"],
    category: "Proxy",
    form: SecurityPlaceholderForm,
    type: "zscalerProxy",
    img: "https://assets.whatslly.com/product/img/logos/destination-zscaler.png",
    className: "zscaler-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "sonicwall-firewall",
    name: DESTINATION_NAMES["sonicWallFirewall"],
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "sonicWallFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-sonicwall.png",
    className: "sonicwall-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "cisco-firewall",
    name: DESTINATION_NAMES["ciscoFirewall"],
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "ciscoFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-cisco.png",
    className: "cisco-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "microsoft-defender-endpoint",
    name: DESTINATION_NAMES["microsoftDefenderEndpoint"],
    category: "Endpoint",
    form: SecurityPlaceholderForm,
    type: "microsoftDefenderEndpoint",
    img: "https://assets.whatslly.com/product/img/logos/destination-microsoft-defender.png",
    className: "microsoftDefender-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "carbon-black-endpoint",
    name: DESTINATION_NAMES["carbonBlackEndpoint"],
    category: "Endpoint",
    form: SecurityPlaceholderForm,
    type: "carbonBlackEndpoint",
    img: "https://assets.whatslly.com/product/img/logos/destination-carbon-black.png",
    className: "carbonBlack-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "sophos-firewall",
    name: DESTINATION_NAMES["sophosFirewall"],
    category: "Firewall",
    form: SecurityPlaceholderForm,
    type: "sophosFirewall",
    img: "https://assets.whatslly.com/product/img/logos/destination-sophos.png",
    className: "sophos-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.SECURITY,
  },
  {
    id: "virus-total-file-scan",
    name: DESTINATION_NAMES["virusTotalFileScan"],
    category: "destinations_page.file_scanning_category",
    form: SecurityPlaceholderForm,
    type: "virusTotalFileScan",
    img: "https://assets.whatslly.com/product/img/logos/destination-virustotal.png",
    className: "virusTotal-img",
    isActive: () => true,
    integrationType: DESTINATION_INTEGRATION_TYPES.FILE_SCANNING,
  },
] as const;

export const DestinationListMap = keyBy(DestinationList, "type");
export const DestinationListMapById = keyBy(DestinationList, "id");
